export interface Inquiry {
  inquiryId: string;
  inquiryNumber: number;
  userId: string;
  username: string;
  question: string;
  isNew: boolean;
  createdAt: string;
  updatedAt: string;
  isClosed: boolean;
  answers: InquiryAnswer[];
}

export interface InquiryAnswer {
  userId: string;
  username: string;
  answer: string;
  createdAt: Date;
  role: 'operator' | 'patient';
}

export const inquiryHeader = {
  'inquiryId': '問合せ番号',
  'username': 'ユーザID',
  'isNew': '新着',
  'updatedAt': '最終更新日時',
  // 'isClose': 'Close',
};



// WEBPACK FOOTER //
// ./src/constants/InquiryListField.tsx